export const DEFAULT_CATEGORY_TITLE = 'Dokumen Rujukan'

export const DEFAULT_CATEGORY_DESCRIPTION =
  'Kumpulan dokumen panduan, regulasi, inspirasi penerapan, dan lain-lain.'

export const DEFAULT_CATEGORY_THUMBNAIL =
  '/illustrations/img-folder-document.png'

export const SHARE_TEXT = 'Bapak/Ibu Guru, coba cek dokumen rujukan berikut.'

export const DOWNLOAD_TOAST_MESSAGE =
  'Mengunduh dokumen. Lihat progresnya pada notifikasi ponsel.'

export const HELPDESK_LINK =
  'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/30654044178713-Apa-Itu-Fitur-Kumpulan-Dokumen'
